import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ModalDialog } from 'components/ModalDialog';
import type { ActKc3RegistryItem } from 'gql/graphql';
import { formatDateToLocale } from 'utils';

import type { RowClassRules } from 'ag-grid-community';
import { useMemo } from 'react';

import { useTotalsColumns } from './hooks/useTotalsColumns';
import { useTotalsData } from './hooks/useTotalsData';

import Styles from './ActKC3Totals.module.css';

type TActKC3Totals = {
    onClose: () => void;
    kc3ForTotalsData: ActKc3RegistryItem;
};
const getName = (number: string | undefined | null): string => {
    if (!number) {
        return '';
    }
    const actNameStartsWithNumber = number?.toString()?.startsWith('№');

    if (actNameStartsWithNumber) {
        return number;
    }

    return `№${number}`;
};

const rowRules: RowClassRules = {
    grayRow: (p) => !!p?.data?.isHeadLine,
    commonRow: (p) => !p?.data?.isHeadLine,
};

export const ActKC3Totals = (props: TActKC3Totals) => {
    const { onClose, kc3ForTotalsData } = props;

    const modalTitle = useMemo(() => {
        const date = kc3ForTotalsData?.actKC3Date ? `от ${formatDateToLocale(kc3ForTotalsData?.actKC3Date)}` : '';

        return `${kc3ForTotalsData?.actKC3IsCorrection ? 'Корректировочная ' : ''} Справка КС-3 ${getName(
            kc3ForTotalsData?.actKC3FullNumber,
        )} ${date} (Отчетный период ${formatDateToLocale(
            kc3ForTotalsData?.actKC3ReportingStartDate,
        )}-${formatDateToLocale(kc3ForTotalsData?.actKC3ReportingFinishDate)})`;
    }, [
        kc3ForTotalsData?.actKC3Date,
        kc3ForTotalsData?.actKC3FullNumber,
        kc3ForTotalsData?.actKC3IsCorrection,
        kc3ForTotalsData?.actKC3ReportingFinishDate,
        kc3ForTotalsData?.actKC3ReportingStartDate,
    ]);

    const { groupedData, toggleOthersCollapse, othersCollapseState, hasNotOthersData } = useTotalsData(
        kc3ForTotalsData?.actKC3Id,
    );
    const columns = useTotalsColumns({ toggleOthersCollapse, othersCollapseState, hasNotOthersData });

    return (
        <ModalDialog
            title={modalTitle}
            onClose={onClose}
            dockedToWindow="bottom"
            hasOverlay
            isOpen
            withTitleCloseButton
            isOnClickOutsideDisable
            withBottomButtons={false}
        >
            <div style={{ padding: '20px', height: '550px' }}>
                <AgGridTable
                    columnDefs={columns}
                    rowData={groupedData}
                    rowClassRules={rowRules}
                    className={Styles.kc3TotalTable}
                />
            </div>
        </ModalDialog>
    );
};

ActKC3Totals.displayName = 'ActKC3Totals';
